import React, { memo } from 'react'

import { string } from 'prop-types'

import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'

function Keywords({ keywords = '' }) {
  return (
    <div className="search-subscription__keywords">
      {keywords}
    </div>
  )
}

Keywords.propTypes = {
  keywords: string,
}

const mapStateToProps = ({
  pageCategory,
  selectedFilters: {
    keywords,
  }
}) => ({
  keywords: keywords || pageCategory || '',
})

export default WithTriangleUiContext(mapStateToProps)(memo(Keywords))
